import type { LoSiteBlock } from '@/lib/lyrraone-site-blocks';
import type { LoSiteColumnsLayout } from '@/lib/lyrraone-site-theme-profiles';
import type { LoSiteElementStyle } from '@/lib/lyrraone-site-elements';
import { elementStyleClass, elementStyleToCss } from '@/lib/lyrraone-site-elements';
import { ThemeEditable } from '@/components/lyrraone/site-themes/LoSiteThemeEditable';
import { cn } from '@/lib/utils';

interface LoSiteThemedColumnsProps {
  layout: LoSiteColumnsLayout;
  block: LoSiteBlock;
  blockKey: string;
  colCount: 2 | 3;
  editMode?: boolean;
  selectedElementKey?: string | null;
  onSelectElement?: (key: string) => void;
  onInlineTextChange?: (key: string, value: string) => void;
  styleOf: (key: string) => LoSiteElementStyle | undefined;
}

export function LoSiteThemedColumns({
  layout,
  block,
  blockKey,
  colCount,
  editMode,
  selectedElementKey,
  onSelectElement,
  onInlineTextChange,
  styleOf,
}: LoSiteThemedColumnsProps) {
  const columns = block.columns ?? [];
  const blockType = colCount === 2 ? 'columns2' : 'columns3';

  return (
    <section
      key={blockKey}
      className={cn('lo-st-columns', `lo-st-columns--${layout}`, `lo-st-columns--${colCount}`)}
    >
      <div className="lo-wrap">
        <div className="lo-st-columns__grid">
          {Array.from({ length: colCount }, (_, i) => {
            const cell = columns[i];
            const elementKey = `${blockType}.col.${i}`;
            return (
              <ThemeEditable
                key={elementKey}
                elementKey={elementKey}
                editMode={editMode}
                selectedElementKey={selectedElementKey}
                onSelectElement={onSelectElement}
                onInlineTextChange={onInlineTextChange}
                className={cn('lo-st-columns__cell', elementStyleClass(styleOf(elementKey)))}
                style={elementStyleToCss(styleOf(elementKey))}
                as="div"
                editableText
              >
                {cell?.body ?? `Colonne ${i + 1}`}
              </ThemeEditable>
            );
          })}
        </div>
      </div>
    </section>
  );
}
